const CONSTANTS = {
    observerGap: window.innerWidth > 576 ? "-300px" : "0px",
};

export default CONSTANTS